import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ResolverService } from 'src/app/___LOGIC/__common/resolver.service';
import Swiper from 'swiper';

@Component({
  selector: 'app-pricing-plans',
  templateUrl: './pricing-plans.component.html',
  styleUrls: ['./pricing-plans.component.css']
})
export class PricingPlansComponent implements OnInit  {

  @Input() packages;
  @Input() myRouteId;

  arrayResult = [];

  cards = [
    {
      title: 'Estudios, cursos y becas...',
      section: 'academic',
      category: 'Acedémico',
      img: "assets/voyjaleas/academic.jpeg",
      selected: true,
    }
  ];
  
  constructor(private resolver: ResolverService) { }

  ngOnInit(): void {
    this.getPackagesByType();
  }
  
  isPackChosen(pack){
    if(pack && pack.FK_ID_package_chosen){
      return pack.FK_ID_package_chosen == pack.id
    }else{
      return false;
    }
  }

  isLoading(){
    return this.resolver.isLoading('getPackDetails');
  }

  getOldPrice(price){
    price = parseInt(price) + 20;
    return price;
  }

  getPackagesByType(){
    let basic = {};
    let premium = {};
    let full = {};
    
    if(this.packages.length>0){
      for(let item of JSON.parse(this.packages)){
        if(item.package_type === 'basic'){
            basic['price'] = item.price;
            basic['paid'] = item.paid;
            basic['id'] = item.id;
            basic['name'] = item.name;
            basic['FK_ID_package_chosen'] = item.FK_ID_package_chosen;
        }
        if(item.package_type === 'premium'){
          premium['price'] = item.price;
          premium['paid'] = item.paid;
          premium['id'] = item.id;
          premium['name'] = item.name;
          premium['FK_ID_package_chosen'] = item.FK_ID_package_chosen;
        }
        if(item.package_type === 'full'){
          full['price'] = item.price;
          full['paid'] = item.paid;
          full['id'] = item.id;
          full['name'] = item.name;
          full['FK_ID_package_chosen'] = item.FK_ID_package_chosen;
        }
      }

      basic['products'] = this.resolver.getCachePacks()[0]['products'];
      premium['products'] = this.resolver.getCachePacks()[1]['products'];
      full['products'] = this.resolver.getCachePacks()[2]['products'];
      this.arrayResult.push(basic);
      this.arrayResult.push(premium);
      this.arrayResult.push(full);

      
      return this.arrayResult;
    }else{
      return []
    }
  }

}
